<template>
<div>
    <Breadcrumbs main="Procurement" title="RFP Responses" />

    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="d-flex justify-content-end mb-3">
                    <b-button variant="primary" @click="goBack">
                        <div style="display: flex; align-items: center; gap: 8px;">
                            <feather type="arrow-left" size="18px"></feather>
                            <h7>Back</h7>
                        </div>
                    </b-button>
                </div>

                <!-- RFP Details -->
                <div class="card mb-3">
                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h5 class="card-title mb-0">{{ comparison.rfp.title }}</h5>
                            <span class="badge bg-primary">{{ comparison.rfp.rfp_id }}</span>
                        </div>
                        <div class="row g-2">
                            <div class="col-auto">
                                <small class="text-muted">Status:</small>
                                <small class="badge bg-info ml-1">{{ comparison.rfp.status }}</small>
                            </div>
                            <div class="col-auto">
                                <small class="text-muted">Deadline:</small>
                                <strong class="ml-1">{{ comparison.rfp.deadline }}</strong>
                            </div>
                            <div class="col-auto">
                                <small class="text-muted">Category:</small>
                                <strong class="ml-1">{{ comparison.rfp.category }}</strong>
                            </div>
                            <div class="col-auto">
                                <small class="text-muted">Submissions:</small>
                                <strong class="ml-1">{{ comparison.total_submissions }}</strong>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Submissions -->
                <div class="card">
                    <div class="card-body">
                        <h6 class="card-subtitle text-muted mb-3">{{ comparison.form.form_name }}</h6>
                        <div v-for="sub in comparison.submissions" :key="sub.submission_id" class="d-flex py-3 border-bottom" style="gap: 8px; width: 100%;">
                            <div style="width: 100%;">
                                <div class="d-flex flex-wrap justify-content-between">
                                    <div>
                                        <strong>{{ sub.vendor.company }}</strong>
                                        <span class="badge ml-2" :class="sub.approved ? 'bg-success' : 'bg-secondary'">
                                            {{ sub.approved ? 'Approved' : 'Pending' }}
                                        </span>
                                    </div>
                                    <div class="d-flex align-items-center" style="gap: 8px;">
                                        <feather type="check" size="22px" style="color: #000000; cursor: pointer;" v-b-tooltip.hover @click="selectedID(sub.submission_id)" title="Assign Vendor"></feather>
                                         <feather type="message-circle" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-scrollable @click="Reply(sub.submission_id)" title="Reply"></feather>
                                        <feather type="tag" size="22px" style="color: #A927F9; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center-add @click="add(sub)" title="Add label"></feather>
                                       
                                    </div>
                                </div>
                                <div class="d-flex flex-wrap my-2" style="gap: 6px;">
                                    <div v-for="label in sub.labels" :key="label.id" class="">
                                        <small class="badge badge-light">{{ label.name }}</small>
                                    </div>
                                </div>

                                <div class="text-muted small">{{ sub.vendor.email }} · {{ sub.vendor.vendor_id }}</div>
                                <div v-for="fo in sub.form_data" :key="fo.data_label" class="mt-2 ">
                                        <div v-if="fo.data_type === 'filefield'">
                                            <div @click="redirectToFullUrl(getFullPath(fo))">
                                                <b-form-input :value="getFullPath(fo)" type="text" class="clickable-input text-info" readonly></b-form-input>

                                            </div>
                                        </div>
                                        <div v-else-if="fo.data_type === 'textfield'">
                                            <div>
                                                <b-form-input v-model="fo.data_value" type="text" readonly class=""></b-form-input>
                                            </div>
                                        </div>
                                        <div v-else-if="fo.data_type === 'paragraph'">
                                            <div>
                                                <textarea class="form-control" id="textarea-auto-height" rows="3" max-rows="8" v-model="fo.data_value" readonly></textarea>
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <!-- Reply Modal -->
    <b-modal id="modal-scrollable" ref="modal" title="Submission Reply" hide-footer>

        <div style="margin-top: 30px;" v-if="rfp_reply.length>0">
            <h6>Replies</h6>
            <div class="task-board-comments">
                <div v-for="reply in rfp_reply" :key="reply.id" class="chatbox">
                    <div class="chat">
                        <div class="avatar">
                            <img :src="host + reply.replied_by.photo" alt="" v-b-tooltip.hover :title="reply.replied_by.first_name + ' ' + reply.replied_by.last_name" v-if="reply.replied_by.photo">
                        </div>
                        <div class="message">
                            <h7 class="name pl-1">{{ reply.replied_by.username }}</h7>
                            <p class="msg" v-html="convertUrls(reply.reply)"></p>
                            <!-- <p class="msg" v-b-tooltip.hover :title="reply.reply_date">{{ reply.reply }}</p> -->
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="task-board-comment-box" style="margin-top: 10px;">
            <div style="display: flex; gap: 12px;">
                <input class="form-control" type="text" v-model="my_reply.reply" placeholder="Write your reply here..." @keyup.enter="handleReplySubmit()">
                <button @click="handleReplySubmit()" class="btn btn-primary">Send</button>
            </div>
        </div>
    </b-modal>

    <!-- Assign Modal -->
    <b-modal id="modal_vendor_assign" centered hide-header @ok="handleAssignOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to assign this vendor?</div>
    </b-modal>

    <!-- Label -->
    <b-modal id="modal-center-add" centered title="Add Label" @ok="handleLabelOK">
        <div class="row">
            <div class="col-sm-12">

                <h6 v-if="addedLabels.length>0">Already Added</h6>
                <div class="row">
                    <div class="text-center col-sm-6 w-full" v-for="label in addedLabels" :key="label.id" v-b-tooltip.hover @click="deleteAssignedLabel(label.id)" title="Delete">
                        <div class="w-100 mb-2 badge-style">
                            <h7>{{ label.name}}</h7>
                            <b-icon icon="x" style="color: white;"></b-icon>
                        </div>
                    </div>
                </div>

                <div class="form-group mt-2">
                    <label>Label</label>
                    <select class="form-control digits" v-model="label_id">
                        <option v-for="(type, index) in labels" :key="index" :value="type.id">{{ type.name }}</option>
                    </select>
                </div>
            </div>
        </div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import {
    myHost
} from "../../../_helpers/host";

export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker
    },

    data() {
        return {
            host: myHost.host,
            delete_value: '',

            response_id: '',
            label_id: null,
            addedLabels: [],
            selectedLabel: null,

            filter: null,
            my_reply: {
                id: '',
                reply: '',

            },
            submission_id: null,

        }
    },

    computed: {
        ...mapState({
            labels: state => state.rfp.rfp_label_list,
            comparison: state => state.rfp.rfp_response_comparison,
            rfp_reply: state => state.rfp.rfp_response_reply,
        }),
        // filteredResponses() {
        //     if (!this.selectedLabel) {
        //         return this.responses;
        //     }
        //     return this.responses.filter(response =>
        //         response.label.some(label => label.name === this.selectedLabel)
        //     );
        // }
        sortOptions() {
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    mounted() {
        this.$store.dispatch("rfp/fetchFormResponses", this.$route.params.id).then(() => {
            this.items = this.responses
            this.totalRows = this.items.length;
        });
        this.$store.dispatch("rfp/fetchRFPLabels")
        this.$store.dispatch("rfp/getRFPResponseComparison", this.$route.query.rfp)
    },

    watch: {
        responses(newValue, oldValue) {}
    },

    methods: {
        getFullPath(fo) {
            return this.host + fo.data_value;
        },
        redirectToFullUrl(fullUrl) {
            window.open(fullUrl, '_blank'); 
           
        },
        convertUrls(text) {
            if (text === null) {
                return '';
            }
            const urlPattern = /(https?:\/\/[^\s<]+)/g;
            return text.replace(urlPattern, (url) => {
                return `<a href="${url}" target="_blank" class="text-primary">${url}</a>`;
            });
        },
        Reply(id) {
            this.my_reply.id = id
            this.$store.dispatch("rfp/fetchRFPResponseReply", this.my_reply.id)
        },
        selectedID(id) {
            this.submission_id = id
            this.$nextTick(() => {
                this.$bvModal.show('modal_vendor_assign')
            })
        },
        goBack() {
            if (window.history.length > 1) {
                this.$router.back();
            } else {
                this.$router.push('/dashboard');
            }
        },
        handleReplySubmit() {
            this.$store.dispatch("rfp/addRFPResponseReply", {
                submission: this.my_reply.id,
                reply: this.my_reply.reply,

            }).then(response => {

                if (response.code == 200) {
                    // Swal.fire({
                    //     title: "Success!",
                    //     text: response.response,
                    //     icon: "success"
                    // });

                    this.my_reply.reply = ''

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

        },

        handleAssignOk() {
            this.$store.dispatch("rfp/assignVendorByFormResponse", {
                rfp: this.$route.query.rfp,
                submission_id: this.submission_id
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.submission_id = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        deleteItem(id) {
            this.delete_value = id
        },

        add(data) {
            this.submission_id = data.submission_id
            this.addedLabels = data.labels
        },

        handleLabelOK() {
            this.$store.dispatch("rfp/addLabelToResponse", {
                response_id: this.submission_id,
                label_id: this.label_id,
                form_response: this.comparison.form.id,
                rfp: this.$route.query.rfp
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.label_id = null
                    this.submission_id = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        deleteAssignedLabel(id) {
            this.$store.dispatch("rfp/deleteLabelFromResponse", {
                response_id: this.submission_id,
                label_id: id,
                form_response: this.comparison.form.id,
                rfp: this.$route.query.rfp
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.label_id = null
                    this.submission_id = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            this.$nextTick(() => {
                this.$bvModal.hide('modal-center-add')
            })
        },

        handleDeleteOk() {
            this.$store.dispatch("rfp/deleterfpFormResonse", {
                response_id: this.delete_value,
                rfp_id: this.$route.params.id
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        addLabel() {
            if (this.label !== '') {
                this.$store.dispatch("rfp/addRFPLabel", this.label).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.label = ''

                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            }
        },

        deleteLabel(id) {
            this.$store.dispatch("rfp/deleteRFPLabel", id).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

    }
};
</script>

<style scoped>
.badge-style {
    display: flex;
    justify-content: space-between;
    align-items: center;
    justify-items: center;
    background-color: #2c323f;
    padding: 0.375rem 1.75rem;
    color: white;
}

.badge-style:hover {
    background-color: #ff595d;
}

.clickable-input {
    border: none;
    outline: none;
    background-color: transparent;
    color: blue;
    cursor: pointer;

}

.chatbox {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 0px 10px;
}

.chat {
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;
    word-break: break-all;
}

.avatar img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    border: solid 2px white;
}

.message {
    flex-grow: 1;
}

.msg {
    background: #fff0f0;
    width: 100%;
    /* Ensures message takes full width */
    padding: 10px;
    border-radius: 10px;
    position: relative;
    font-size: 13px;
}

.task-board-comments {
    height: 450px;
    overflow-y: auto;
}

/* height */
::-webkit-scrollbar {
    height: 6px;
    width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #555;
}
</style>
